import React, { useState, useEffect } from "react";
import { Modal, Nav, Tabs, Tab } from "react-bootstrap";
import { i18n } from "@lingui/core";
import CommonSearch from "../../SeacrhDomain/ComonSearch";
import { useForm } from "react-hook-form";
import SearchDomain from "../../SeacrhDomain";
import { useMutation } from "@apollo/client";
import { CHECK_DOMAIN, HOSTING_UPGRADE_PACKAGE } from "../../../../gql/hosting";
import {
  CREATE_CART_DOMAIN,
  CREATE_CART_HOSTING,
  FETCH_CART,
} from "../../../../gql/cart";
import {
  Button,
  Typography,
  Grid,
  Card,
  CardSection,
} from "@pmberjaya/cloudbank-ui";
import { validHostname } from "../../../../utils/FormatDomain";
import { useRouter } from "next/router";
import { toast } from "react-toastify";
// import {  ModalBody, ModalFooter, Typography } from "@pmberjaya/cloudbank-ui";
const DetailHosting = (props) => {
  const { register, setValue, handleSubmit, watch } = useForm({
    defaultValues: {
      domain_name: "",
    },
  });

  const {
    data,
    packages,
    bonusDuration,
    hostName,
    hostId,
    open,
    setOpen,
    isUpgrade,
    voucherCode,
  } = props;
  const route = useRouter();
  const [keyTab, setKeyTab] = useState(0);

  const [domainName, setDomainName] = useState("");
  const [values, setValues] = React.useState(0);
  const [packageId, setPackageId] = React.useState("1");
  const [isError, setIsError] = useState();
  const [duration, setDuration] = useState("1");
  const [isAvailable, setIsAvailable] = useState();
  useEffect(() => {
    if (data !== undefined) {
      {
        isUpgrade && setPackageId(packages[packages.length - 1].id);
      }

      if (bonusDuration !== undefined) {
        setDuration(bonusDuration);
      } else {
        setDuration(
          data === undefined
            ? 1
            : data?.hosting_package_pricing.filter(
                (item) => item.discount_promo !== null
              )[0]
            ? data?.hosting_package_pricing.filter(
                (item) => item.discount_promo !== null
              )[0].duration
            : data?.hosting_package_pricing[0].duration
        );
      }
    }
  }, [data, bonusDuration]);

  //   useEffect(() => {
  //     if (watch("domain_name").length > 1) {
  //       setIsAvailable();
  //       setIsError();
  //       watch("domain_name");
  //     }
  //     // eslint-disable-next-line
  //   }, [watch("domain_name")]);

  const [checkDomain, { loading: loadCheckDomain, error: errorCheckDomain }] =
    useMutation(CHECK_DOMAIN, {
      onCompleted: (resp) => {
        setIsAvailable(resp.domain.domainOps.checkDomain.available);
        setDomainName(resp.domain.domainOps.checkDomain.domain);
      },
      onError: (resp) => {
        toast(resp.message, {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_LEFT,
        });
      },
    });

  const [upgradeHostingPkg, { loading: upgradeLoad }] = useMutation(
    HOSTING_UPGRADE_PACKAGE,
    {
      onCompleted: (resp) => {
        window.open(`${process.env.REACT_APP_NEW_DOMAIN}cart`, "_self");
      },
      onError: (resp) => {
        toast(resp.message, {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_LEFT,
        });
      },
    }
  );

  const [addToCart, { loading: loadAdd }] = useMutation(CREATE_CART_HOSTING, {
    onCompleted: () => {
      setOpen(false);
      setIsAvailable();
      if (route.pathname.includes("cart")) {
      } else if (route.pathname.includes("promo")) {
        window.open(
          `${process.env.REACT_APP_DOMAIN}cart?voucher=${voucherCode}`,
          "_self"
        );
      } else {
        window.open(`${process.env.REACT_APP_NEW_DOMAIN}cart`, "_self");
      }
    },
    onError: (resp) => {
      setIsError(true);
      toast(resp.message, {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.BOTTOM_LEFT,
      });
    },
    update(cache, { data }) {
      const list = cache.readQuery({
        query: FETCH_CART,
        variables: {
          action_type: 1,
        },
      });
      cache.writeQuery({
        query: FETCH_CART,
        data: {
          billing_hosting: {
            ...list.billing_hosting,
            carts: [
              ...list.billing_hosting.carts,
              data.billing.cartOps.createCartHosting,
            ],
          },
        },
      });
    },
  });

  const [addToCartDomain, { loading: loadAddDomain }] = useMutation(
    CREATE_CART_DOMAIN,
    {
      onCompleted: () => {
        setIsAvailable();
      },
      onError: (resp) => {
        setIsError(true);
        toast(resp.message, {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_LEFT,
        });
      },
      update(cache, { data }) {
        const list = cache.readQuery({
          query: FETCH_CART,
          variables: {
            action_type: 1,
          },
        });
        cache.writeQuery({
          query: FETCH_CART,
          data: {
            billing_hosting: {
              ...list.billing_hosting,
              carts: [
                ...list.billing_hosting.carts,
                data.billing.cartOps.createCartDomain,
              ],
            },
          },
        });
      },
    }
  );

  const handleCheckDomain = (data) => {
    setIsAvailable();
    setIsError();
    // setDomainName(data.domain_name);

    checkDomain({
      variables: {
        Domain: domainName,
      },
    });
  };

  const handleAddToCart = () => {
    if (isUpgrade) {
      upgradeHostingPkg({
        variables: {
          input: {
            id: hostId,
            package_id: parseInt(packageId),
            qty: duration.toString(),
          },
        },
      });
    } else {
      if (domainName === "") {
        alert("Masukkan nama domain Anda");
      } else {
        if (keyTab === 0) {
          addToCartDomain({
            variables: {
              input: {
                name: domainName,
                is_premium: false,
              },
            },
          });
        }

        addToCart({
          variables: {
            input: {
              name: domainName,
              package_id: parseInt(data.id),
              qty: duration.toString(),
            },
          },
        });
      }
    }
  };

  const handleChange = (event, newValue) => {
    setIsAvailable();
    setIsError();
    setValues(newValue);
  };

  const handleChangeName = (e) => {
    setDomainName(e);
    setIsError();
  };
  const handleClose = () => {
    setDomainName("");
    setIsAvailable();
    setOpen(false);
  };
  return (
    <>
      <Modal show={open} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>
            <Typography fontWeight="bold">Rincian Pilihan Paket</Typography>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isUpgrade ? (
            <Grid row className="gx-3 mb-3">
              {packages?.map((row) => (
                <Grid
                  key={row.id}
                  className={`${row.id === data?.id && "disabled"}`}
                  col
                  xs={12}
                  sm={6}
                  lg={4}
                  onClick={() => setPackageId(row.id)}
                >
                  <Card
                    className={`shadow pointer ${
                      row.id === data?.id && "opacity-50"
                    } border ${
                      packageId === row.id
                        ? "border-success border-2"
                        : "border-light"
                    } my-2`}
                  >
                    <CardSection>
                      <div className="mb-3 d-flex justify-content-between align-items-center">
                        <p className="mb-0 fw-bold text-uppercase">
                          {row.name}
                        </p>
                        {packageId === row.id && (
                          <i className="bi bi-check-circle-fill text-success"></i>
                        )}
                      </div>
                      <p className="mb-0 text-secondary secondary-text text-uppercase">
                        mulai dari
                      </p>
                      <h5 className="text-primary mb-0">
                        {i18n.number(
                          row.hosting_package_pricing[0].discount_promo !== null
                            ? row.hosting_package_pricing[0].price -
                                row.hosting_package_pricing[0].discount_promo
                                  .discount
                            : row.hosting_package_pricing[0].price,
                          {
                            currency: "IDR",
                            style: "currency",
                            minimumFractionDigits: 0,
                          }
                        )}
                      </h5>
                      <p className="mb-0 secondary-text text-secondary">
                        / bulan
                      </p>
                    </CardSection>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="h5" fontWeight="bolder">
              {" "}
              {data?.name}
            </Typography>
          )}

          {/* {isUpgrade ? (
            <input value={hostName} className="form-control" disabled />
          ) : null} */}

          {isUpgrade ? (
            <select
              className="form-select"
              onChange={(e) => setDuration(e.target.value)}
              value={duration}
            >
              {packages
                ?.find((pkg) => pkg.id === packageId)
                ?.hosting_package_pricing.map((row) => (
                  <option value={row.duration} key={row}>
                    {row.discount_promo !== null && " Promo"} {row.duration}{" "}
                    bulan -{" "}
                    {i18n.number(
                      row.discount_promo !== null
                        ? row.price - row.discount_promo.discount
                        : row.price,
                      {
                        currency: "IDR",
                        style: "currency",
                        minimumFractionDigits: 0,
                      }
                    )}
                  </option>
                ))}
            </select>
          ) : (
            <select
              className="form-select"
              onChange={(e) => setDuration(e.target.value)}
              value={duration}
              disabled={bonusDuration !== undefined}
            >
              {data?.hosting_package_pricing?.map((row) => (
                <>
                  <option value={row.duration}>
                    {row.duration} bulan -{" "}
                    {i18n.number(
                      row.discount_promo !== null
                        ? row.price - row.discount_promo.discount
                        : row.price,
                      {
                        currency: "IDR",
                        style: "currency",
                        minimumFractionDigits: 0,
                      }
                    )}
                    {row.discount_promo !== null && " Promo"}{" "}
                  </option>
                </>
              ))}
            </select>
          )}

          {isUpgrade ? null : (
            <>
              <Grid mt={2}>
                <Typography
                  variant="h3"
                  textTransform="capitalize"
                  fontWeight="bolder"
                >
                  Pilih Domain
                </Typography>
              </Grid>
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav variant="pills" className="flex-column">
                  <div className="row">
                    <div className="col-5 text-uppercase">
                      <Nav.Item>
                        <Nav.Link eventKey="first" onClick={() => setKeyTab()}>
                          Domain Baru
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                    <div className="col-7 text-uppercase">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="second"
                          onClick={() => setKeyTab(1)}
                        >
                          Sudah Memiliki Domain
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </div>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <form onSubmit={handleSubmit(handleCheckDomain)}>
                      <div className="input-group ">
                        <input
                          // {...register("domain_name", { required: true })}
                          onChange={(e) => handleChangeName(e.target.value)}
                          className=" border-primary form-control"
                        />

                        <span className="input-group-append">
                          <button
                            className="btn btn-outline-primary  "
                            type="submit"
                            disabled={loadCheckDomain}
                          >
                            <span className="icon-search"></span>
                          </button>
                        </span>
                      </div>
                      {domainName.replace(validHostname, "") && (
                        <span className="text-danger">
                          Mohon masukan sebuah nama host domain
                        </span>
                      )}
                    </form>
                    <div className="d-flex align-items-center p-1">
                      {loadCheckDomain ? (
                        <>
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          ></div>
                          <p className="ps-1">Loading...</p>
                        </>
                      ) : errorCheckDomain ? (
                        <>
                          <p className="text-alert">
                            <span className="icon-cancel-circle text-danger fs-5"></span>
                            {errorCheckDomain.message === "record not found"
                              ? "Maaf, domain extension belum tersedia"
                              : errorCheckDomain.message}
                          </p>
                        </>
                      ) : null}
                      {isAvailable === 1 ? (
                        <>
                          <p>
                            <span className="icon-tick text-success fs-5 pe-1"></span>
                            Hore! Domain Anda tersedia!{" "}
                          </p>
                        </>
                      ) : isAvailable === 0 ? (
                        <>
                          <span className="icon-cancel-circle text-danger"></span>
                          <p className="ps-1">Domain tidak tersedia.</p>
                        </>
                      ) : null}
                      {/* {errorAddDomain && <p>Error add to cart...</p>} */}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <input
                      type="text"
                      className="form-control "
                      placeholder="MASUKAN NAMA DOMAIN"
                      onChange={(e) => handleChangeName(e.target.value)}
                    />
                    {domainName.replace(validHostname, "") && (
                      <span className="text-danger">
                        Mohon masukan sebuah nama host domain
                      </span>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {isAvailable === 1 || keyTab === 1 ? (
            <Button variant="contained" onClick={handleAddToCart}>
              <span>Tambah</span>
            </Button>
          ) : null}
          {isUpgrade ? (
            <Button
              variant="contained"
              onClick={handleAddToCart}
              disabled={upgradeLoad}
            >
              Lanjutkan ke Pembayaran
            </Button>
          ) : null}

          <Button
            variant="contained"
            color="secondary"
            onClick={() => handleClose()}
          >
            tutup
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DetailHosting;
